import React from 'react';
import ProductCard from './resultcards/ProductCard';

interface DomainResultCardProps {
  title: string;
  description: string;
  image_url: string;
  url: string;
  type: string;
}

const DomainResultCard: React.FC<DomainResultCardProps> = (props) => {
  // For now, we only support product type
  if (props.type === 'product') {
    return <ProductCard {...props} />;
  }

  // Fallback to product card if type is not recognized
  return <ProductCard {...props} />;
};

export default DomainResultCard; 